//import services from "../services";
import * as types from "./mutation-type";

import services from "../services";

export const ActionSetGlobal = ({commit}, payload) => {
    commit(types.SET_GLOBAL, payload)
}

export const ActionSetPrivate = async ({commit}, payload) => {
    commit(types.SET_PRIVATE, payload)
}

export const AcionsBroadcast = () => {
    return {
        logout: services.logout,
        checkLogin: services.checkLogin,
    }
}

export const ActionGetToken = () => {
    return new Promise(async (resolve, reject) => {
        try {
            const { data } = await services.getToken();
            if(data.error) {
                return reject(data)
            }
            resolve(data)
        } catch (error) {
            reject(error?.response?.data ?? error)
        }
    })
}

